import {ImportStatus} from '../model/types';

export type BaseResponse<T> = {
  code: number;
  message: string;
  data: T;
};

export type StandardWorkingTimeQuestion = {
  workOnTime: string;
  workOffTime: string;
  dayStartTime: string;
  baseLine: string;
  restTimes: {
    startTime: string;
    endTime: string;
  }[];
};

export type ElasticWorkingTimeQuestion = {
  isEnabled: boolean;
  elasticScaleBefore: number;
  elasticScaleAfter: number;
  unitOfTime: number;
};

export type ScheduleInfoQuestion = {
  hasEnabled: boolean;
  workingHourType: number;
  scheduleDaysInEveryMonth: {
    start: number;
    end: number;
  };
  scheduleItems: number[];
};

export type AttendanceQuestions = {
  standardWorkingTime: StandardWorkingTimeQuestion;
  elasticWorkingTime: ElasticWorkingTimeQuestion;
  scheduleInfo: ScheduleInfoQuestion;
};

export type ImportStatusResponse = {
  importStateId: string;
  fdStatus: ImportStatus;
  ptStatus: ImportStatus;
  pyStatus: ImportStatus;
  status: ImportStatus;
};

export enum CycleType {
  none = 1,
  weekly = 0,
}

export const cycleTypeOptions = [
  {
    value: CycleType.none,
    label: '不重複',
  },
  {
    value: CycleType.weekly,
    label: '每週',
  },
]

export enum WorkType {
  work = 0, // 上班
  weekend = 1, // 週休二日
  dayOff = 2, //休息日
  vacation = 3, //例假日
}

export type Cycles = {
  sunday?: WorkType;
  monday?: WorkType;
  tuesday?: WorkType;
  wednesday?: WorkType;
  thursday?: WorkType;
  friday?: WorkType;
  saturday?: WorkType;
} 
export type ShiftSchedule = {
  error?: any;
  id: string;
  name: string;
  startWorkingTime: string;
  offWorkingTime: string;
  dayStartTime: string;
  restTimes: {startTime: string; endTime: string}[];
  color: string;
  cycleType: CycleType;
  cycles: Cycles;
};

export enum CalendarType
{
	templeteCalendar = 0, // 範本行事曆
	emptyCalendar = 1, // 空白行事曆(排班用)
	partTimeCalendar = 2, // 時薪人員用行事曆
}

export const calendarTypeOptions = [
  {
    value: CalendarType.templeteCalendar,
    label: '範本行事曆',
  },
  {
    value: CalendarType.emptyCalendar,
    label: '空白行事曆(排班用)',
  },
  {
    value: CalendarType.partTimeCalendar,
    label: '時薪人員用行事曆',
  },
]
export type Shift = {
  error?: any;
  id: string;
  storeName: string;
  baseLine: string;
  cycleType: CycleType,
  shiftScheduleCalendarType: CalendarType,
  isAutoGenerateCalendar: boolean,
  standardShiftSchedule: {
    shiftScheduleId: string | null;
    shiftScheduleName: string;
  } | null;
  defaultShiftSchedule?: {
    shiftScheduleId?: string;
    shiftScheduleName: string;
  };
  shiftSchedules: {
    shiftScheduleId: string;
    shiftScheduleName: string;
  }[];
};

export type EmployeeSchedule = {
  id: string;
  shift: {
    shiftId: string;
    shiftName: string;
  };
  appliedUnit: string;
  units: {id: string; name: string}[];
};

export type ScheduleSettingBody = {
  shiftSchedules: ShiftSchedule[];
  shifts: Shift[];
  employeeSchedules: EmployeeSchedule[];
};

export type Bank = {
  bankId: string;
  code: string;
  name: string;
  transferFileType: string;
};

export type InsuranceUnit = {
  insuranceApplicantUnitId: string;
  insuranceApplicantUnitName: string;
  insuranceNo: string;
  insuranceCheckNo: string;
  occupationalInjuryRate: number;
  nHIUnitCode: string;
  nHIBusinessGroupCode: string;
};
export type IncomeTaxRegistrationUnit = {
  incomeTaxReturnUnitId: string;
  declarationName: string;
  unifiedBusinessNo: string;
  collectionAuthorityCode: string;
  declarationHouseLogicSerialNumber: string;
  deductObligor: string;
  withholdingUnitLogicSerialNumber: string;
  declarationAddress: string;
  contactName: string;
  responsiblePersonName: string;
  mobilePhone: string;
  email: string;
};
export type PayrollCompanySetting = {
  banks: Bank[];
  insuranceUnits: InsuranceUnit[];
  incomeTaxRegistrationUnits: IncomeTaxRegistrationUnit[];
};

export enum SalaryCategory {
  hourly = 0,
  monthly = 1,
}

export enum SubjectCategory {
  basicSalary = '001',
  fixedAllowance = '0011',
}

export enum DefaultBasicSubjectCode {
  hourlySalary = '1002',
  baseSalary = '1000',
  foodAllowance = '1001',
}

export const foodAllowanceUpperLimit = 3000

export const defaultBasicSubjectCodes: string[] = [
  DefaultBasicSubjectCode.baseSalary,
  DefaultBasicSubjectCode.foodAllowance,
  DefaultBasicSubjectCode.hourlySalary,
]
export const salaryCategory = [
  {
    label: '時薪制',
    value: SalaryCategory.hourly,
  },
  {
    label: '月薪制',
    value: SalaryCategory.monthly,
  },
];

export type SalaryAccount = {
  salaryAccountCategoryId: string;
  hnSalaryAccountCode: string | null;
  hnSalaryAccountName: string | null;
  salaryAccountId: string | null;
  salaryAccountCode: string;
  salaryAccountName: string;
  money?: string;
}
export type UserInfoResponse = {
  email: string;
  id: string;
  name: string;
  isActive: boolean;
};
